<template>
  <v-dialog
    v-model="dialog"
    max-width="800"
  >
    <template v-slot:activator="{ on }">
      <a
        href="javascript:;"
        class="d-inline-block px-1"
        v-on="on"
      >{{ $t('TaskList.Detail') }}
      </a>
    </template>
    <v-card>
      <v-card-title>
        {{ $t('Outbox.FlowRecords') }}
      </v-card-title>
      <v-card-text>
        <table class="text--primary">
          <tr v-if="receiverInfosOrdered.length">
            <td>--</td>
            <td>
              <span
                v-if="receiverInfosOrdered[0].statusCode === DOC_FLOW_STATUS.CANCEL"
              >
                ({{ $t('Text.Cancel') }})
              </span>
              <span
                v-else-if="receiverInfosOrdered[0].statusCode === DOC_FLOW_STATUS.CLOSED"
              >
                ({{ $t('DocFlow.StatusCode.CLOSED') }})
              </span>
              <span v-else>
                {{ $t('TaskList.Waiting') + '&nbsp;' }}
                <template v-if="receiverInfosOrdered[0].notifiedGid">
                  {{ $chPtObjData('chinNotifiedGroupName', receiverInfosOrdered[0]) }}
                </template>
                <template v-else>
                  {{ $chPtObjData('chinNotifiedStaffName', receiverInfosOrdered[0]) }}
                </template>
              </span>
            </td>
          </tr>
          <tr
            v-for="(receiverInfo) in receiverInfosOrdered"
            :key="receiverInfo.id"
          >
            <td class="font-weight-light pr-4">
              {{ momentWithHyphen(receiverInfo.createdTime).format('YYYY-MM-DD HH:mm') }}
            </td>
            <td>
              {{ $chPtObjData('chinSenderName', receiverInfo) }}
            </td>
          </tr>
        </table>
      </v-card-text>
      <v-card-actions>
        <v-btn
          text
          color="primary"
          @click="dialog = false"
        >
          {{ $t('PublicServant.Action.Close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped>
  table td {
    padding-bottom: 4px;
  }
</style>

<script>

import { momentWithHyphen } from '@/utils/datetimeUtil'
import { DOC_FLOW_STATUS } from '@/constant/constant'

export default {
  components: {
  },
  props: {
    processMcReceiverInfos: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data: function () {
    return {
      dialog: false,
      DOC_FLOW_STATUS
    }
  },
  computed: {
    receiverInfosOrdered: function () {
      return this.processMcReceiverInfos.slice().reverse()
    }
  },
  methods: {
    momentWithHyphen: momentWithHyphen
  }
}
</script>
